import { render } from "./IDateFlatpickr.vue?vue&type=template&id=38573632&scoped=true"
import script from "./IDateFlatpickr.vue?vue&type=script&lang=js"
export * from "./IDateFlatpickr.vue?vue&type=script&lang=js"

import "./IDateFlatpickr.vue?vue&type=style&index=0&id=38573632&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38573632"]])

export default __exports__